import { useLocalization } from '@/shared/hooks/useLocalization'
import type { Currency } from '@/shared/models/moneyModel'
import type { BadgeProps } from '@/shared/v2/shared/components/Badge'
import Badge from '@/shared/v2/shared/components/Badge'
import { isNil } from 'lodash'

export type BalanceBadgeProps = {
    balance: number | undefined
    currency: Currency | undefined
}
const resolveBadgeIntent = (balance: number): BadgeProps['intent'] => {
    if (isNil(balance)) return 'default'
    return balance >= 0 ? 'positive' : 'negative'
}

const BalanceBadge = ({ balance, currency }: BalanceBadgeProps) => {
    if (isNil(balance) || isNil(currency)) return null

    const { localizeAmounts } = useLocalization()

    const displayBalance = localizeAmounts(balance, currency)

    return (
        <Badge
            data-testid="__balance-badge__"
            intent={resolveBadgeIntent(balance)}
            className="flex items-center gap-x-2"
        >
            {balance && balance > 0 ? `+${displayBalance}` : displayBalance}
        </Badge>
    )
}

export default BalanceBadge
